export default {
  title: 'Añadir partner',
  mode: {
    single: 'Socio individual',
    bulk: 'Masivo (CSV)',
  },
  buttons: {
    send_invite: 'Enviar invitación',
  },
  bulk: {
    form: {
      file: {
        label: 'Lista de socios (CSV)',
        hint: 'Un socio por fila. Columnas obligatorias: Email, País de la empresa y Nombre registrado o Nombre de la empresa. El nombre de marca es opcional y se convierte en el nombre visible para el consumidor. Cada fila se valida antes de crear nada.',
      },
    },
    buttons: {
      select_file: 'Seleccionar archivo CSV',
      download_template: 'Descargar plantilla de importación',
      import: 'Importar socios',
    },
    columns: {
      legal_name: 'Nombre registrado de la empresa / Nombre de la empresa',
      display_name: 'Nombre de marca',
      admin_email: 'Email',
      company_country: 'País de la empresa',
    },
    errors: {
      title: 'El archivo no se pudo importar.',
      nothing_imported: 'No se creó ningún socio. Corrija las filas anteriores y suba el archivo de nuevo.',
      columns: {
        row: 'Fila',
        column: 'Columna',
        error: 'Error',
      },
    },
    toasts: {
      queued_one:
        '{{count}} socio en cola — las invitaciones se envían a medida que se crea cada uno. Recibirá un resumen por email cuando finalice la importación.',
      queued_other:
        '{{count}} socios en cola — las invitaciones se envían a medida que se crea cada uno. Recibirá un resumen por email cuando finalice la importación.',
    },
    footnote:
      'Los socios se crean uno por uno en segundo plano con la misma configuración que un socio individual: correo de invitación, subdominio del panel y dominio de tienda predeterminado. El país determina la moneda y la zona horaria; el estado se puede configurar más tarde desde el perfil del socio. El procesamiento de pagos se configura después en la pestaña Pagos de cada socio.',
  },
  form: {
    name: {
      label: 'Nombre del partner',
    },
    admin_email: {
      label: 'Correo del administrador (destinatario de la invitación)',
      hint: 'Enviaremos una invitación por correo para configurar su cuenta.',
    },
    display_name: {
      label: 'Nombre visible para consumidores',
      hint: 'La etiqueta «Con tecnología de ___» que ven los clientes. Si se deja en blanco, se usa el nombre del partner.',
    },
    region: {
      label: 'País',
      placeholder: 'Seleccionar un país',
      hint: 'Define la moneda, la zona horaria y el idioma de la invitación del partner.',
      summary: 'Moneda {{currency}} · {{timezone}} · Idioma de invitación {{language}}',
      default_root: 'Dominio de la tienda: las nuevas marcas se sirven en {{host}}',
    },
    sub_region: {
      label: 'Estado/Provincia',
      placeholder: 'Todo el país',
      hint: 'Opcional — dejar vacío para aplicar a todo el país.',
    },
    language: {
      label: 'Idioma de la invitación',
      placeholder: '{{language}} (predeterminado)',
      hint: 'Opcional — usa el idioma principal del país por defecto.',
    },
  },
  footnote: 'Las opciones de marca y ganancias se pueden configurar después de que el partner acepte su invitación.',
  toasts: {
    created: 'Partner creado — el correo de invitación está en camino.',
  },
};
